import styled from 'styled-components';

export const ArtDecoFrame = styled.div`
  border: 18px solid transparent;
  outline: 2px solid ${({ theme }) => theme.colors.primary};
  outline-offset: -10px;
  background:
    linear-gradient(${({ theme }) => theme.colors.primary} 0 0) top,
    linear-gradient(${({ theme }) => theme.colors.primary} 0 0) left,
    linear-gradient(${({ theme }) => theme.colors.primary} 0 0) bottom,
    linear-gradient(${({ theme }) => theme.colors.primary} 0 0) right;
  background-size: 200% 2px, 2px 200%;
  background-origin: padding-box;
  background-repeat: no-repeat;
  height: 100%;


  padding: 10px;
  margin: 20px; 
  text-align: center;

  // &::before {
  //   margin: 28px; 
  //   content: "";
  //   position: absolute;
  //   top: -10px;
  //   left: -10px;
  //   right: -10px;
  //   bottom: -10px;
  //   border: 2px solid ${({ theme }) => theme.colors.primary};
  //   pointer-events: none;
  // }

  h1,
  p {
    color: ${({ theme }) => theme.colors.primary};
  }

  h1 {
    font-size: 3em;
    font-weight: 800;
  }
`;
